<template>
  <div class="picture-preview-container">
    <image-viewer ref="imgViewer" :z-index="9999" :initial-index="index" :url-list="imgList" :on-close="closeViewer"/>
  </div>
</template>

<script>
import ImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  name: 'picture-preview',
  props: ['coverPicList', 'src'],
  components: {ImageViewer},
  data () {
    return {
      imgList: [],
      index: 0
    }
  },
  methods: {
    closeViewer () {
      this.$emit('closePreview')
    }
  },
  created () {
    if (this.coverPicList && this.coverPicList.length) {
      let index = this.coverPicList.findIndex(c => c.url === this.src)
      this.index = index > -1 ? index : 0
      this.imgList = this.coverPicList.map(m => {
        return m.url.includes('http') ? m.url : sessionStorage.getItem('ossDownloadUrl') + m.url
      })
    }
  },
  mounted () {
    this.$refs.imgViewer.infinite = false
    let el = this.$refs.imgViewer.$el
    el.addEventListener('dblclick', e => {
      e.stopPropagation()
      return false
    })
  }
}
</script>

<style lang="scss">
  .picture-preview-container {
    & > .el-image-viewer__wrapper {
      .el-image-viewer__btn {
        &:hover {
          color: #5cb6ff;
        }
        &:active {
          color: #54abf2;
        }
        & > .el-icon-arrow-left, & > .el-icon-arrow-right {
          font-size: 23px;
        }
      }
      .el-image-viewer__actions__inner {
        & > i {
          cursor: pointer;
          font-size: 23px;
          &:hover {
            color: #5cb6ff;
          }
          &:active {
            color: #54abf2;
          }
        }
      }
      .el-image-viewer__close {
        outline: none;
        .el-icon-circle-close {
          outline: none;
          opacity: 1;
          font-size: 40px;
          color: #606266;
          &:hover {
            color: #f56c6c;
          }
          &:active {
            color: #FA4B4B;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/picture-preview-swiper.vue